// extracted by mini-css-extract-plugin
module.exports = {"item":"breadcrumbItem_item__3YzB8","link":"breadcrumbItem_link__3xcly"};